// extracted by mini-css-extract-plugin
export default {"zoomModal":"f3-z","image":"g3-z","button":"h3-z","isOverlayShown":"i3-z"};